import Helper from "./Helper";
import Overlay from './Overlay';

class Indikatoren {
  constructor(config = {}) {
    const {
      griIndiSelector,
      sasbIndiSelector,
      ungcIndiSelector
    } = config;

    this.griIndi = document.querySelectorAll(griIndiSelector);
    this.ungcIndi = document.querySelectorAll(ungcIndiSelector);
    this.sasbIndi = document.querySelectorAll(sasbIndiSelector);

    this.griLink;
    this.sasbLink;
    this.filter1;
    this.filter2;
    this.filter3;
    this.filter4;
    this.filter5;

    this.overlayInstance = null;

    this.bindJson();

    this.bindUrlEvents();

    if(this.griIndi.length !== -1 && this.griLink){
      this.bindGriLinks();
    }

    if(this.ungcIndi.length !== -1 && this.griLink){
      this.bindUngcLinks();
    }

    if(this.sasbIndi.length !== -1 && this.sasbLink){
      this.bindSasbLinks();
    }

    if(this.filter1 || this.filter2 || this.filter3 || this.filter4 || this.filter5){
      this.bindTagFilter();
    }
  }

  bindJson(){
    if(indikatoren_json){
      for (let key in indikatoren_json['indikatoren']){
        this.griLink = indikatoren_json['indikatoren']['gri'];
        this.sasbLink = indikatoren_json['indikatoren']['sasb'];
        // this.filter1 = indikatoren_json['indikatoren']['filter1'] === "Co2-Reduktion" ? "CO₂-Reduktion" : indikatoren_json['indikatoren']['filter1'];
        // this.filter2 = indikatoren_json['indikatoren']['filter2'] === "Co2-Reduktion" ? "CO₂-Reduktion" : indikatoren_json['indikatoren']['filter2'];
        // this.filter3 = indikatoren_json['indikatoren']['filter3'] === "Co2-Reduktion" ? "CO₂-Reduktion" : indikatoren_json['indikatoren']['filter3'];
        // this.filter4 = indikatoren_json['indikatoren']['filter4'] === "Co2-Reduktion" ? "CO₂-Reduktion" : indikatoren_json['indikatoren']['filter4'];
        // this.filter5 = indikatoren_json['indikatoren']['filter5'] === "Co2-Reduktion" ? "CO₂-Reduktion" : indikatoren_json['indikatoren']['filter5'];
      }
    }
  }

  bindUrlEvents(){
    const url = location.href;

    if(url.indexOf('?gri=') !== -1 || url.indexOf('?ungc=') !== -1){
      let id = !!url.split('?gri=')[1] ? url.split('?gri=')[1] : url.split('?ungc=')[1];

      if(!!id){

        id = id.replace(/\-/g,'–').replace(/\%20/g,' ');

        const xpath = "//span[text()='" + id + "']";
        const matchingElement = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;

        matchingElement.closest('.ns-accordion__content').previousElementSibling.click();

        setTimeout(() => {
          const yOffset = - 30 - matchingElement.closest('td').offsetHeight;
          const y = matchingElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }, 1000);

      }

    } else if(url.indexOf('?sasb=') !== -1){

      let id = url.split('?sasb=')[1];

      if(!!id){

        const xpath = "//span[text()='" + id + "']";
        const matchingElement = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;

        setTimeout(() => {
          const yOffset = - 10 - matchingElement.closest('td').offsetHeight;
          const y = matchingElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }, 500);

      }

    }
  }

  bindGriLinks(){
    this.griIndi.forEach(gri => {
      gri.innerHTML = `<a href="${this.griLink}&gri=${gri.innerText}">${gri.innerText}</a>`;
    });
  }

  bindUngcLinks(){
    this.ungcIndi.forEach(ungc => {
      ungc.innerHTML = `<a href="${this.griLink}&ungc=${ungc.innerText}">${ungc.innerText}</a>`;
    });
  }

  bindSasbLinks(){
    this.sasbIndi.forEach(sasb => {
      sasb.innerHTML = `<a href="${this.sasbLink}&sasb=${sasb.innerText}">${sasb.innerText}</a>`;
    });
  }

  bindTagFilter(){
    let language = document.querySelector("html").getAttribute("lang");
    let filterText = "Topics";

    if(language == "de-DE"){
      filterText = "Themen";
    }

    let filterHtml = `
    <div class="ns-flex-container">
      <div class="ns-flex-container__title">
        <p class="ns-indikator-container__title">${filterText}</p>
      </div>
      <div class="ns-flex-container__content">
    `;

    if(this.filter1) filterHtml += `<p class="ns-indikator ns-indikator--themenfilter js-tagmag-box js-tagmag-box-name"># ${this.filter1}</p>`;
    if(this.filter2) filterHtml += `<p class="ns-indikator ns-indikator--themenfilter js-tagmag-box js-tagmag-box-name"># ${this.filter2}</p>`;
    if(this.filter3) filterHtml += `<p class="ns-indikator ns-indikator--themenfilter js-tagmag-box js-tagmag-box-name"># ${this.filter3}</p>`;
    if(this.filter4) filterHtml += `<p class="ns-indikator ns-indikator--themenfilter js-tagmag-box js-tagmag-box-name"># ${this.filter4}</p>`;
    if(this.filter5) filterHtml += `<p class="ns-indikator ns-indikator--themenfilter js-tagmag-box js-tagmag-box-name"># ${this.filter5}</p>`;

    filterHtml += `
      </div>
    `;

    let contentInner = document.querySelector('.content__inner');
    let lastIndikator = contentInner.querySelectorAll('.ns-indikator');
    let position;

    if(lastIndikator.length !== 0){
      position = lastIndikator[lastIndikator.length - 1].closest('.ns-flex-container');
    } else {
      position = contentInner.firstElementChild;
    }

    if(position){
      position.insertAdjacentHTML('afterend', filterHtml);

      this.overlayInstance = new Overlay({
        overlayButtonSelector: '.sidebar__button[href]',
        overlayTagmagButtonSelector: '.sidebar__button--tagfilter',
        openerSelector: ".js-tagmag-box",
        openerTagSelector: ".js-tagmag-box-name"
      });
    }
  }

}
export default Indikatoren;
